import React, { FC, RefObject, useRef, useState } from 'react'
import { ATTACHMENT_EXTRAFIELD } from '../../../../models/post'

import { TMediaCallbacks } from '../../../../pages/CreatePost'
import {
  TChangeAttachmentExtrafieldPayload,
  TExtendedPostAttachment,
  TRemoveAttachmentPayload
} from '../../../../store/managePost/newTypes'
import GeneralForm from '../../../Form'
import TrashIcon from '../../../UI/Icons/Trash'
import TextAreaInput from '../../../UI/Inputs/TextAreaInput'

import './UI.scss'

type LinkPreviewProps = {
  attachment: TExtendedPostAttachment | null
  isEditable: boolean
  setExtraField?: (data: TChangeAttachmentExtrafieldPayload) => void
  refMediaCallbaks?: RefObject<TMediaCallbacks>
  addLinkToAttachments?: (isChildLink: boolean) => void
  deleteMediaFromPostSocial?: (data: TRemoveAttachmentPayload) => void
}

const LinkPreview: FC<LinkPreviewProps> = ({
  attachment,
  setExtraField,
  addLinkToAttachments,
  deleteMediaFromPostSocial,
  isEditable,
  refMediaCallbaks
}) => {
  const formRef = useRef<any>(null)
  const [isEditLink, setIsEditLink] = useState<boolean>(false)

  if (refMediaCallbaks && refMediaCallbaks.current) {
    refMediaCallbaks.current.startEditLink = (isFocusInput: boolean) => {
      isFocusInput && setIsEditLink(true)
      if (!attachment) {
        addLinkToAttachments && addLinkToAttachments(false)
      }
    }
  }

  const onBlurInput = () => {
    if (
      formRef.current &&
      !Object.keys(formRef.current.errors).length &&
      attachment &&
      setExtraField
    ) {
      let onChangePayload: TChangeAttachmentExtrafieldPayload = {
        value: formRef.current.values.link,
        field: ATTACHMENT_EXTRAFIELD.LINK
      }

      if (!!attachment?.id) onChangePayload.id = attachment.id
      else if (!!attachment?.temporaryId) onChangePayload.temporaryId = attachment.temporaryId

      setExtraField && setExtraField(onChangePayload)
      setIsEditLink(false)
    }
  }

  const removeLink = () => {
    setIsEditLink(false)
    if (attachment) {
      const { id, temporaryId } = attachment
      deleteMediaFromPostSocial && deleteMediaFromPostSocial({ id, temporaryId })
    }
  }

  const setUpForm = {
    initialValues: { link: attachment?.extra_fields?.link || '' },
    validation: 'link',
    validateOnChange: true,
    innerRef: formRef,
    onSubmit: () => {}
  }

  const link = attachment?.extra_fields?.link

  return link || isEditLink ? (
    <div className='link-preview'>
      <div className='link-preview__image-wrapper'>
        <div className='link-preview__image-wrapper__mock-image' />
      </div>
      <div className='link-preview__data-wrapper'>
        {isEditable && isEditLink ? (
          <GeneralForm {...setUpForm}>
            <TextAreaInput
              name={ATTACHMENT_EXTRAFIELD.LINK}
              customOnBlur={onBlurInput}
              allowUntouchedValidation={true}
            />
          </GeneralForm>
        ) : (
          <a className='link-preview__data-wrapper__link' target='_blank' href={link || ''}>
            {link || ''}
          </a>
        )}
      </div>
      {isEditable && (
        <div className='link-preview__remove' onClick={removeLink}>
          <TrashIcon />
        </div>
      )}
    </div>
  ) : null
}

export default LinkPreview
